import { render, staticRenderFns } from "./TargetAdditionalDataInput.vue?vue&type=template&id=19322e47&scoped=true"
import script from "./TargetAdditionalDataInput.vue?vue&type=script&lang=js"
export * from "./TargetAdditionalDataInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19322e47",
  null
  
)

export default component.exports